<template>
    <div class="search-index">
        <div class="main-content">
           <div class="article-title color-branch-blue fs12">搜索结果 > {{searchValue}}</div>
           <div class="tab-content-box">
                <div class="tab-content clearfix" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.module_id,item.article_id)">
                    <div class="img-left fl">
                        <img :src="item.img_url" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fr">
                        <div class="pt10 title txt_limit">{{item.title}}</div>
                        <div class="pt20 describe txt_limit2" v-if="item.module_id==16" v-html="item.content"></div>
                        <div class="pt20 describe txt_limit2" v-else>{{item.description}}</div>
                        <div class="pt20 more" v-if="item.module_id === '4'">
                            <span class="color-branch-blue fr">查看全部<img src="../../assets/images/branch-arrow-blue.png" alt="" class="arrow-icon"></span>
                        </div>
                        <div class="pt20 more" v-else><span>{{formatTime.getMsecToSpecificTime(item.addtime,'yyyy年MM月dd日 hh:mm:ss')}}</span>
                            <span class="color-branch-blue fr">查看全部<img src="../../assets/images/branch-arrow-blue.png" alt="" class="arrow-icon"></span>
                        </div>
                    </div>
                </div>
           </div>
           <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
            </el-col>
        </div>
    </div>
</template>
<script>
export default {
    props: {

    },
    data() {
        return {
            searchValue:this.$route.params.searchId||'',
            page: 1,//重新获取的当前的页码
            alltotal:10,//总的数据
            pageSize:10,//每一条的页数是10
            dataList:[],
            short_name:this.$route.params.short_name
        };
    },
    watch: {
        $route(to,from){
            this.short_name=to.params.short_name;
            sessionStorage.setItem('english_short_name',this.short_name);
            this.getList();
        }
    },
    created() {
        this.getList(1);
    },
    mounted() {

    },
    watch: {
        $route(to,from){
            this.searchValue=to.params.searchId||'';
            this.getList(1);
        }
    },
    methods: {
        getList(pageIndex) {
            if(pageIndex){
                this.page=pageIndex;
            }
            //tab切换
            this.$axios.post(this.api.index.search+'?perpage='+this.pageSize+'&page='+this.page,{
                search:this.searchValue
            },res =>{
                this.dataList=res.data;
                this.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                this.dataList=[];
            });
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getList();
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getList();
        },
        goDetail:function(module_id,article_id){
            var link=''
            switch(module_id){
                case '2':
                    link='/departDetail/'
                    break;
                case '4':
                    link='/doctorsDetail/'
                    break;
                case '8':
                    link='/dynamicDetail/'
                    break;
                case '16':
                    link='/recruitDetail/'
                    break;
                case '32':
                    link='/healthDetail/'
                    break;
                default:
                    break;
            }
            this.$router.push(link+this.short_name+'/'+article_id+'.html');
        },
    },
    components: {
      
    },
};
</script>
<style scoped>
/* tab列表信息展示 */
.tab-content{margin-bottom:20px;height:220px;padding:20px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content .img-left{width:240px;height:180px;margin-right:20px;}
.tab-content .img-right{width:900px;}
.tab-content .img-right .title{font-size:18px;color:rgba(51,51,51,1);line-height:25px;}
.tab-content .img-right .describe{font-size:14px;color:rgba(102,102,102,1);line-height:20px;height:100px;}
.tab-content .img-right .more{color:rgba(153,153,153,1);line-height:20px;}
</style>


// WEBPACK FOOTER //
// src/view/search/index.vue